import { ReactNode } from 'react';

import { VStack } from '../../Stack';
import { cnUserBar } from '../UserBar';

import './UserBarTopSection.css';

/**
 * Интерфейс компонента верхней секции юзербара UserBarTopSection
 */
interface UserBarTopSectionProps {
    /**
     * Компонент для отображения аккаунта пользователя
     */
    user?: ReactNode;
    /**
     * Вложенный контент секции после пользователя
     * @expectedNode `UserBarItem`
     */
    children?: ReactNode;
    /**
     * Дополнительный класс для верхней секции
     */
    className?: string;
}

/**
 * Компонент UserBarTopSection для отображения верхней секции UserBar'а
 */
export const UserBarTopSection = function UserBarTopSection({ user, children, className }: UserBarTopSectionProps) {
    return (
        <VStack className={cnUserBar('topSection', {}, [className])}>
            {user}
            {children}
        </VStack>
    );
};
